import "./App.css";
// @ts-ignore
import React, {
  useCallback,
  useState,
  useEffect,
  useMemo,
  useRef,
} from "react";
import { styled } from "styled-components";
// @ts-ignore
// import OpenAI from "openai";
import Scale from "./Scale";
import { MOBILE_SCREEN_WIDTH_BREAKPOINT } from "./constants";
import html2canvas from "html2canvas";

const INIT_COFFEE = `{
    "origin": "Ethiopia",
    "roast_level": "75",
    "funk_level": "30",
    "flavor_notes": ["Blueberry", "Chocolate", "Floral", "Citrus"],
    "processing_method": "Washed",
    "cultivar_intro": "In the highlands where coffee blooms, the sun kisses berries, crafting tales of blueberry and chocolate. Each sip whispers of nature's dance, a fragrant journey wrapped in floral dreams and citrus kisses, inviting you to wander amidst the clouds.",
    "person_intro": "The cultivator has a small family farm nestled in a lush valley, carrying traditions passed down for generations.",
    "color_hex": {
        "first": "#4A90E2",
        "second": "#8E44AD"
    }
}`;

const DEFAULT_NAME = "Bungalow Bill";

// const client = new OpenAI({
//   apiKey: process.env["REACT_APP_OPENAI_API_KEY"],
//   dangerouslyAllowBrowser: true,
// });

// console.log(process.env["REACT_APP_OPENAI_API_KEY"]);

function App() {
  // eslint-disable-next-line no-unused-vars
  const [coffee, setCoffee] = useState(JSON.parse(INIT_COFFEE));
  const [name, setName] = useState("");

  const [isLoadingCoffee, setIsLoadingCoffee] = useState(false);
  const [errorLoadingCoffee, setErrorLoadingCoffee] = useState(false);

  const labelRef = useRef(null);

  const getGradient = useMemo(() => {
    const circlePosition =
      Math.random() > 0.5 ? `circle at right` : `circle at left`;

    return circlePosition;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coffee]);

  const onClick = useCallback(async () => {
    setIsLoadingCoffee(true);
    // const completion = await client.chat.completions.create({
    //   model: "gpt-4o-mini",
    //   messages: [
    //     {
    //       role: "user",
    //       content: `Generate a coffee label with origin, roast level (as a percentage where 0 - light, 100 - darkness, only number), a funk percentage that goes from 0 (Clean) - 100% (Funky) to describe how evocative the coffee notes/flavors are inline with bean, method and flavor notes. 3-4 flavor notes (1-2 words each, very very specific), processing method (randomly include 1 word bean type if exotic like Gesha, Sidra, Ombligon and other obscure beans) with variety (no comma, title case), and a brief intro on bean cultivar, technicalities of processing method & geography (150 char) and about the cultivator/fermenter (add a specific personal detail about ${name}, where they're from, geography or family detail but no name) (150 char) be specific . Also add two colors as hex values, which correspond to the top two tasting notes (make sure colors are bright enough for black text overlay). Make sure the roast level makes sense for the bean, processing and flavor notes. Return it as a json so i can parse it. Only the json, nothing else. No code formatting. Structure: {
    //   "origin": "string",
    //   "roast_level": "number",
    //   "funk_level": "number"
    //   "flavor_notes": [],
    //   "processing_method": "string",
    //   "cultivar_intro": "string",
    //   "person_intro": "string",
    //   "color_hex": {
    //     "first": "#string",
    //     "second": "#string"
    //   }`,
    //     },
    //   ],
    // });

    try {
      const result = await fetch("/.netlify/functions/coffeeLabel", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
      });
      const data = await result.json();

      const newCoffee = data.choices[0].message.content;
      setCoffee(JSON.parse(newCoffee));
    } catch (e) {
      console.error(e);
      setErrorLoadingCoffee(true);
      setIsLoadingCoffee(false);
      setTimeout(() => {
        setErrorLoadingCoffee(false);
      }, 2000);
    }

    setIsLoadingCoffee(false);

    // const response = completion.choices[0].message.content;
    // console.log(response);
    // setCoffee(JSON.parse(response));
  }, [name]);

  useEffect(() => {
    console.log(coffee);
  }, [coffee]);

  const handleExport = async () => {
    // @ts-ignore
    if (labelRef.current) {
      // @ts-ignore
      const canvas = await html2canvas(labelRef.current);
      const image = canvas.toDataURL("image/png");

      // download the image
      const link = document.createElement("a");
      link.href = image;
      link.download = `coffee_${
        name || DEFAULT_NAME.replace(/ /g, "_")
      }_${coffee.processing_method.replace(/ /g, "_")}.png`;
      link.click();
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <p>Specailty Coffee Generator</p>
      </header>
      <MainContent>
        <Name>
          <NameInput
            id="textInput"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your name"
          />
          {errorLoadingCoffee ? (
            <ButtonSuspense>
              <ButtonSuspenseLabel
                // @ts-ignore
                $error
              >
                {`Error Generating Coffee :(`}
              </ButtonSuspenseLabel>
            </ButtonSuspense>
          ) : isLoadingCoffee ? (
            <ButtonSuspense>
              <ButtonSuspenseLabel>Generating Coffee</ButtonSuspenseLabel>
              <Spinner />
            </ButtonSuspense>
          ) : (
            <GenerateCoffeeButton disabled={isLoadingCoffee} onClick={onClick}>
              Generate Coffee Label
            </GenerateCoffeeButton>
          )}
        </Name>
        <Wrapper>
          <CoffeeLabel
            ref={labelRef}
            // @ts-ignore
            $gradient={getGradient}
            $firstcolor={coffee.color_hex.first}
            $secondcolor={coffee.color_hex.second}
          >
            <div
              style={{
                borderBottom: `solid 2px black`,
                margin: `0 0 16px 0`,
                display: `flex`,
                flexDirection: `row`,
                justifyContent: `space-between`,
              }}
            >
              <Cultivar>{name || DEFAULT_NAME}</Cultivar>
              <Method>{coffee.processing_method}</Method>
            </div>
            <Notes>
              {coffee.flavor_notes.map((note, index) => (
                <p key={index}>{note.toLowerCase()}</p>
              ))}
            </Notes>
            <Scale
              highLabel={"Dark"}
              lowLabel={"Light"}
              percentage={coffee.roast_level}
            />
            <Scale
              highLabel={"Funky"}
              lowLabel={"Clean"}
              percentage={coffee.funk_level}
            />
            {/* </div> */}
          </CoffeeLabel>
          <Description>
            <p>
              <b>MEET THE PRODUCER</b> {coffee.person_intro}
            </p>
            <p>
              <b>TRUST THE PROCESS</b> {coffee.cultivar_intro}
            </p>
          </Description>
        </Wrapper>
        <DownloadButton onClick={handleExport}>
          Download Coffee Label
        </DownloadButton>
      </MainContent>
      <Footer>
        <p>
          This toy project is brought to you by{" "}
          <a href={"https://acrosspolyethylene.com"}>Sumanth Srinivasan</a>
        </p>
      </Footer>
    </div>
  );
}

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px 5% 0 5%;
`;

const Name = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;

  @media only screen and (max-width: ${MOBILE_SCREEN_WIDTH_BREAKPOINT}px) {
    flex-direction: column;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  @media only screen and (max-width: ${MOBILE_SCREEN_WIDTH_BREAKPOINT}px) {
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }
`;

const Description = styled.div`
  font-size: 20px;
  max-width: 500px;
  min-width: 30%;
  flex-grow: 1;

  > p {
    text-align: left;
  }

  @media only screen and (max-width: ${MOBILE_SCREEN_WIDTH_BREAKPOINT}px) {
    > p {
      text-align: center;
      font-size: 16px;
    }
  }
`;

const NameInput = styled.input`
  min-width: 200px;
  height: 42px;
`;

const GenerateCoffeeButton = styled.button`
  min-width: 200px;
  height: 48px;
  background: #333;
  color: #fff;
  cursor: pointer;
`;

const DownloadButton = styled.button`
  min-width: 200px;
  height: 48px;
  background: #333;
  color: #fff;
  cursor: pointer;
`;

const ButtonSuspense = styled.div`
  min-width: 200px;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  margin-top: 0;
`;

const ButtonSuspenseLabel = styled.p`
  font-size: 14px;
  line-height: 40px;

  ${(props) =>
    // @ts-ignore
    props.$error ? `color: #a00` : ``};
`;
const Spinner = styled.div`
  width: 12px;
  height: 12px;
  display: inline-block;
  margin-left: 12px;
  border: 3px solid #ccc;
  border-top: 3px solid #333;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
`;

const Cultivar = styled.p`
  margin: 48px 0 16px 0;
  color: #000;
  font-size: 32px;
  line-height: 28px;
  font-weight: 500;
  text-align: left;
  padding-left: 0;
  vertical-align: baseline;
`;

const Method = styled.p`
  margin: 48px 0 16px 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 200;
  color: #000;
  vertical-align: baseline;
`;

const Notes = styled.div`
  text-align: left;
  color: #000;
  font-weight: 500;
  font-size: 20px;
  line-height: 16px;
`;

const CoffeeLabel = styled.div`
  height: 450px;
  width: 450px;
  min-width: 400px;
  background: ${(props) =>
    // @ts-ignore
    `radial-gradient(${props.$gradient}, ${props.$firstcolor}, ${props.$secondcolor})`};
  padding-left: 32px;
  padding-right: 32px;

  @media only screen and (max-width: ${MOBILE_SCREEN_WIDTH_BREAKPOINT}px) {
    width: 320px;
    height: 360px;
    min-width: unset;
    padding-left: 20px;
    padding-right: 20px;

    ${Cultivar} {
      font-size: 28px;
      line-height: 24px;
      margin: 40px 0 12px 0;
    }

    ${Method} {
      font-size: 20px;
      margin: 40px 0 12px 0;
    }

    ${Notes} {
      font-size: 16px;
      line-height: 12px;
    }
  }
`;

const Footer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  font-size: 12px;
  line-height: 16px;
  color: #282c34;
  gap: 8px;
  border-bottom: 1px solid #282c34;
  background: rgba(255, 255, 255, 0.6);

  > a:link,
  a:visited {
    text-decoration: underline;
    color: #282c34;
  }
`;

export default App;
